import * as React from "react";
import "./Paragraphs.scss";

export class ParagraphDescription extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {
        return <p {...this.props} style={{ color: "#888888", fontSize: 24, lineHeight: "36px", fontFamily: "Open Sans", ...this.props.style }} />
    }
}

export class ParagraphRegular extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {
        return <p {...this.props} style={{ overflowWrap: "break-word", fontFamily: "Open Sans", color: "#555555", fontSize: 21, lineHeight: "32px", ...this.props.style }} />
    }
}

export class ParagraphMedium extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {
        return <p className="paragraph-medium" {...this.props} style={{ ...this.props.style }} />
    }
}

export class ParagraphSmall extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {
        return <p {...this.props} style={{ fontFamily: "Open Sans", color: "#555555", fontSize: 16, lineHeight: "26px", ...this.props.style }} />
    }
}

export class ParagraphError extends React.Component<React.HTMLAttributes<HTMLParagraphElement>>{

    public render() {
        return <p {...this.props} style={{ fontFamily: "Open Sans", color: "#B52D2D", fontSize: 18, lineHeight: "28px", ...this.props.style }} />
    }
}

export class H4Overline extends React.Component<React.HTMLAttributes<HTMLHeadingElement>>{

    public render() {
        return <h4 {...this.props} style={{ fontFamily: "Open Sans", color: "#888888", fontSize: 16, lineHeight: "60px", ...this.props.style }} />
    }
}

export class Headline1 extends React.Component<React.HTMLAttributes<HTMLHeadingElement>>{
    public render() {
        return <h4 {...this.props} style={{ fontFamily: "Lato", color: "#111111", fontSize: 44, lineHeight: "56px", ...this.props.style }} />
    }
}



// WEBPACK FOOTER //
// ./src/components/common/Paragraphs/Paragraphs.tsx